function addAtribute(el) {
	if (el.nodeName !== '#text') {
		el.setAttribute('data-aos', 'fade-up');
	}
}

function init() {
	const content = document.querySelector('.contents-page__content .container');

	if (content) {
		content.childNodes.forEach((el) => {
			addAtribute(el);
		});
	}
}

export default {
	init,
};
